import { type FC, useEffect } from 'react';
import useMeasure from 'react-use-measure';
import cn from 'classnames';

import { AppRoute } from '@/common/app/routes';
import { useMatchPath } from '@/common/hooks/match-path';
import { setCssVar } from '@/common/lib/cssVar';
import { useAppSelector } from '@/redux/store';

import { LotteryNav } from '../LotteryNav/LotteryNav';
import { Tickets } from '../Tickets/Tickets';

import css from './styles.module.scss';

const LotterBottomMenu: FC = () => {
  const [ref, measure] = useMeasure();
  const lotteryInDraw = useAppSelector(
    (state) => state.lottery.currentTier.inDraw,
  );
  const isHistoryPage = useMatchPath([AppRoute.LOTTERY + '/history']);
  useEffect(() => {
    if (measure.width && measure.height) {
      setCssVar('--lottery-bottom-menu-height', `${measure.height}px`);
    }
  }, [measure, lotteryInDraw]);

  return (
    <div ref={ref} className={css.lotteryBottomMenu}>
      {!lotteryInDraw && !isHistoryPage && (
        <div className="relative h-[60px] w-full">
          <Tickets />
        </div>
      )}
      <LotteryNav className={cn((lotteryInDraw || isHistoryPage) && 'pt-4')} />
    </div>
  );
};

export { LotterBottomMenu };
